import { useCallback, useEffect, useState } from 'react';
import { ProductsOptions } from '.';
import { VoucherFields } from '..';
import { DropdownElement } from 'src/api';

export const useProductValidity = (
  products: DropdownElement[] | null,
  maxProductsShown: number,
  values: VoucherFields,
  selectedValidityProducts: string[] | undefined,
  onChangeValidity: (products: DropdownElement[] | string) => void,
) => {
  const [selectedProducts, setSelectedProducts] = useState<DropdownElement[]>([]);
  const [showAllProducts, setShowAllProducts] = useState(false);
  const [firstColumnProducts, setFirstColumnProducts] = useState<DropdownElement[]>([]);
  const [secondColumnProducts, setSecondColumnProducts] = useState<DropdownElement[]>([]);

  const splitProducts = () => {
    if (!products || products?.length === 0) return;

    let half = Math.ceil(products.length / 2);
    if (half > maxProductsShown / 2 && half % 2 === 0) half--;

    let firstColumn = products.slice(0, half);
    let secondColumn = products.slice(half, products.length);
    if (!showAllProducts) {
      firstColumn = firstColumn.slice(0, maxProductsShown / 2);
      secondColumn = secondColumn.slice(0, maxProductsShown / 2);
    }

    setFirstColumnProducts(firstColumn);
    setSecondColumnProducts(secondColumn);
  };

  useEffect(() => {
    splitProducts();
  }, [products, showAllProducts]);

  useEffect(() => {
    onChangeValidity(
      values.validityProducts === ProductsOptions.ALL_PRODUCTS ? values.validityProducts : selectedProducts,
    );
  }, [values.validityProducts, selectedProducts]);

  useEffect(() => {
    products?.forEach((product) => {
      if (selectedValidityProducts?.includes(product.name)) {
        onChangeProduct(product, true);
      }
    });
  }, [selectedValidityProducts]);

  const onChangeProduct = useCallback(
    (product: DropdownElement, isChecked: boolean) => {
      isChecked ? selectedProducts.push(product) : selectedProducts.splice(selectedProducts.indexOf(product), 1);
      setSelectedProducts([...selectedProducts]);
    },
    [selectedProducts],
  );

  const onProductsValidityChange = useCallback(() => {
    setSelectedProducts([]);
  }, []);

  return {
    selectedProducts,
    firstColumnProducts,
    secondColumnProducts,
    showAllProducts,
    setShowAllProducts,
    onChangeProduct,
    onProductsValidityChange,
  };
};
